import { render, staticRenderFns } from "./deposit_withdraw.vue?vue&type=template&id=65a5ee72&scoped=true&"
import script from "./deposit_withdraw.vue?vue&type=script&lang=js&"
export * from "./deposit_withdraw.vue?vue&type=script&lang=js&"
import style0 from "./deposit_withdraw.vue?vue&type=style&index=0&id=65a5ee72&prod&scoped=true&lang=css&"
import style1 from "./deposit_withdraw.vue?vue&type=style&index=1&id=65a5ee72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5ee72",
  null
  
)

export default component.exports